var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio',{attrs:{"value":_vm.value},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticStyle:{"font-size":"26px","line-height":"40px"}},[_vm._v(_vm._s(_vm.label))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }